import styled from 'styled-components/macro';

const ScoreContainer = styled.div`
  align-items: center;
  background: hsl(0, 0%, 100%);
  border-radius: 5px;
  color: hsl(229, 25%, 31%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0;
  width: 12rem;
`;

export default ScoreContainer;
